<template>
  <div id="profile-page">
    <vs-row>
      <vs-card class="accordin-card mt-5">
        <vs-collapse accordion>
          <vs-collapse-item ref="paymentOptions" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">
                Merchant details <span class="mid-blue">*</span>
              </h3>
            </div>
            <vs-row>
              <vs-col class="pr-6" vs-w="4" vs-xs="12">
                <div>
                  <label class="w-full">Business name *</label>
                  <vs-input v-model="companyName" v-validate="'required'" class="w-full" name="companyName" placeholder="Enter business name" size="large" />
                  <span v-show="errors.has('companyName')" class="text-danger text-sm">{{ errors.first("companyName") }}</span>
                </div>
              </vs-col>
            </vs-row>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>

    <!-- Payment Options -->
    <vs-row>
      <vs-card class="accordin-card mt-5">
        <vs-collapse accordion>
          <vs-collapse-item ref="paymentOptions" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">
                Payment options <span class="mid-blue">*</span>
              </h3>
            </div>
            <p>Select the payment options you'd like to enable for this merchant.</p>
            <vs-row class="mt-8">
              <vs-col class="pr-6" vs-w="4" vs-xs="12">
                <vs-checkbox v-model="paynow" @change="handlePayNow">{{ appName }} payments</vs-checkbox>
              </vs-col>
              <vs-col class="pr-6" vs-w="4" vs-xs="12">
                <vs-checkbox v-model="paylater">{{ appName }} finance products</vs-checkbox>
              </vs-col>
            </vs-row>

            <div class="flex mt-4 justify-between" v-if="paynow">
              <div class="mr-6 segmented-btn-product">
                <vs-checkbox @change="selectDefaultCards()" v-model="payNowOptions" vs-value="CARDS" v-validate="'required'" name="payNowOptions" data-vv-as="payment option">Card payments</vs-checkbox>
                <vs-checkbox v-model="payNowOptions" class="mt-2" vs-value="EFT" v-validate="'required'" name="payNowOptions" data-vv-as="payment option">EFT payments</vs-checkbox>

                <span class="text-danger text-sm" v-show="errors.has('payNowOptions')">{{ errors.first("payNowOptions") }}</span>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>

    <!-- PayNow payment methods -->
    <vs-row>
      <vs-card class="accordin-card mt-5" v-if="paynow && payNowOptions.includes('CARDS')">
        <vs-collapse accordion>
          <vs-collapse-item ref="payNowPaymentMethods" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">
                Card payment settings <span class="mid-blue">*</span>
              </h3>
            </div>
            <div class="mt-4 mb-6">
              <label for="merchantDescriptor">Merchant Descriptor</label>
              <vs-input
                v-model="merchantDescriptor"
                class="w-full"
                name="merchantDescriptor"
                placeholder="Merchant Descriptor"
                size="large"
                @keypress="handleMerchantDescriptorPress($event)"
              />
            </div>
            <span>Set the cards & surcharges to apply to this merchant</span>
            <vs-row>
              <vs-col class="pr-6" vs-w="4" vs-xs="12">
                <vs-row class="m-3 mb-10">
                  <vs-select placeholder="Select payment methods" multiple autocomplete class="selectExample" v-model="selectedCards" @change="checkSelected">
                    <div class="selectAllDiv">
                      <a class="dropdownSelectAllButton" @click="selectAllCards">{{!allCardsSelected ? `Select all` : `Unselect all`}}</a>
                    </div>
                    <vs-select-item :key="index" :value="card" :text="card.title" v-for="(card, index) in cardsList" />
                  </vs-select>
                </vs-row>
              </vs-col>
            </vs-row>

            <!-- groups card -->
            <div class="grid grid-cols-3 gap-5">
              <div class="debit-card flex flex-col" v-for="(card, indextr) in selectedCards" :key="indextr">
                <div class="card__header flex justify-between card-header p-2">
                  <div class="flex w-10/12 items-center">
                    <S3ImageGenerator :document="card.icon" :is-base64="false" :custom-class="'card-image'" :key="card.icon" />
                    <h4 class="m-0 card__title ml-4">{{ card.title }}</h4>
                  </div>
                  <a @click="closeCard(indextr, card._id)">
                    <x-icon size="1.5x" class="custom-class"></x-icon>
                  </a>
                </div>
                <div class="card__body">
                  <div class="card__content p-4">
                    <span class="flex mb-1">MSF <span class="mid-blue">*</span></span>
                    <vs-select placeholder="Select MSF rate" class="selectExample" v-model="card.msf" @change="checkMsf(indextr)">
                      <vs-select-item :key="index" :value="msfRate.msf" :text="msfRate.displayMsf" v-for="(msfRate, index) in getMsfRates(card.title)" />
                    </vs-select>
                    <span class="text-danger text-sm" v-show="errors.has(`msf${indextr}`)">{{ errors.first(`msf${indextr}`) }}</span>
                  </div>
                  <div class="card__content p-4 mb-5">
                    <span>Surcharge to customer </span>
                    <money
                      id="surcharge2"
                      v-bind="money2"
                      v-model.lazy="card.surcharge"
                      :name="`surcharge${indextr}`"
                      data-vv-as="surcharge"
                      v-validate="`required|decimal|max_value:${card.msf}|min_value:0`"
                      @keydown.native="$event.key === '-' ? $event.preventDefault() : null"
                    />
                    <span class="text-danger text-sm" v-show="errors.has(`surcharge${indextr}`)">{{ errors.first(`surcharge${indextr}`) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>

      <!-- This is for Bank accounts part -->
      <vs-card class="accordin-card mt-5 legals" v-if="paynow || paylater">
        <vs-collapse accordion>
          <vs-collapse-item open ref="bankCollapse">
            <div slot="header">
              <h4 class="font-normal text-lg mb-0">Bank accounts</h4>
            </div>
            <div>
              <p class="mb-5">Manage the merchant's verified bank accounts</p>
              <div class="legals__item" v-if="hasPermission">
                <div class="legals__item--header" :class="{'flex-row justify-end items-center':bankAccountList.length > 0,}">
                  <a class="reset-button circular--btn flex" @click="addBankAccountPopup">
                    <plus-icon size="1.5x" class="button-icon mr-2"></plus-icon>Add Account
                  </a>
                </div>
              </div>
              <div class="grid grid-cols-3 gap-5">
                <bank-details-card
                  v-for="(bank, index) in bankAccountList"
                  :bank="bank"
                  :hasPermission="hasPermission"
                  :paymentOptions="paymentOptions"
                  :key="index"
                  @edit="handleEditPopup(bank, index)"
                />
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>

    <!-- payLater products starts here -->
    <vs-row v-if="paylater">
      <vs-card class="accordin-card">
        <vs-collapse accordion>
          <vs-collapse-item ref="paylaterProducts" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">{{ appName }} finance products <span class="mid-blue">*</span></h3>
            </div>

            <p class="mb-4">Manage finance products available to this merchant</p>
            <!-- dropdown -->
            <vs-row>
              <vs-col class="pr-6" vs-w="4" vs-xs="12">
                <vs-row class="m-3 mb-10">
                  <vs-select placeholder="Select products" multiple autocomplete class="selectExample" v-model="selectedProducts" @change="checkSelectedProducts">
                    <div class="selectAllDiv">
                      <a class="dropdownSelectAllButton" @click="selectAllProducts">{{ !allProductsSelected ? "Select all" : "Unselect all" }}</a>
                    </div>
                    <vs-select-item :key="index" :value="paylaterProduct" :text="paylaterProduct.productName" v-for="(paylaterProduct, index) in paylaterProductsList" />
                  </vs-select>
                </vs-row>
              </vs-col>
            </vs-row>
            <vs-row>
              <div class="plans-grid-paylater w-full">
                <div v-for="(plan, index) in selectedProducts" :key="index" class="plans-item">
                  <div class="plan-items__header w-full flex justify-between">
                    <div>
                      <h4>{{ plan.productName }}</h4>
                      <p class="py-2">{{ plan.feeModel == "MSF_INCLUDED" ? "MSF to merchant (MSF-M)" : "MSF to customer (MSF-C)" }}</p>
                      <p>Plan ID:&nbsp;{{ plan.customPlanId ? plan.customPlanId : plan.planId }}</p>
                    </div>
                    <x-icon class="plan-item__close cursor-pointer" size="14" @click="closeProduct(index)"></x-icon>
                  </div>
                  <div class="plan-items-content">
                    <div class="w-1/2">
                      <label class="w-full" :for="`displayNames[${index}]`">Display name</label>
                      <vs-input v-model="plan.displayName" class="w-full mb-2" :name="`displayNames[${index}]`" placeholder="Enter display name" @input="handleManualAssessment" />
                    </div>
                    <div>
                      <div class="justify-between my-4">
                        <div class="flex w-full">
                          <label for="overrideServiceFee">Service fee override</label>
                          <vs-switch class="ml-4" :name="`overrideServiceFee[${index}]`" v-model="plan.overrideServiceFee" @change="handleOverrideServiceFee(plan, index)" />
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="w-1/2">
                          <label class="w-full" for="msfEdit">Service fee</label>
                          <money
                            :disabled="!plan.overrideServiceFee"
                            id="msfEdit"
                            v-bind="money2"
                            v-model.lazy="plan.msf"
                            :name="`msf[${index}]`"
                            data-vv-as="msf"
                            v-validate="`required|decimal`"
                            placeholder="Enter MSF"
                            class="w-full mb-5"
                            @keydown.native="$event.key === '-' ? $event.preventDefault() : null"
                          />
                        </div>
                      </div>
                    </div>

                    <div v-if="showOverrideManualAssessment(plan)">
                      <div class="justify-between my-4">
                        <div class="flex w-full">
                          <label for="overrideGreaterThanAmount">Auto-check/approve override</label>
                          <vs-switch class="ml-4" :name="`overrideGreaterThanAmount[${index}]`" v-model="plan.overrideGreaterThanAmount" @change="handleOverrideGreaterThanAmount(plan, index)" />
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="w-1/2">
                          <label class="w-full" for="manualAssessmentGreaterThanAmount">Manually assess when over:</label>
                          <money
                            :disabled="!plan.overrideGreaterThanAmount"
                            id="manualAssessmentGreaterThanAmount"
                            v-bind="money3"
                            v-model.lazy="plan.manualAssessmentGreaterThanAmount"
                            :name="`manualAssessmentGreaterThanAmount[${index}]`"
                            data-vv-as="amount greater than"
                            v-validate="`required|decimal`"
                            placeholder="Enter amount"
                            class="w-full mb-5"
                            @keydown.native="$event.key === '-' ? $event.preventDefault() : null"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="justify-between mb-4">
                      <div class="flex">
                        <label :for="`isManualAssessment[${index}]`">Manual assessment override</label>
                        <vs-switch class="ml-4" :name="`isManualAssessment[${index}]`" :vs-name="`isManualAssessment[${index}]`" v-model="plan.isManualAssessment" @change="handleManualAssessment" />
                      </div>
                    </div>
                    <div class="mb-4 w-1/2">
                      <label class="w-full" :for="`repayment[${index}]`">Repayment by</label>
                      <vs-select v-model="plan.repaymentBy" :name="`repayment[${index}]`">
                        <vs-select-item value="" text="Select option" />
                        <vs-select-item :key="index" :value="item._id" :text="item.title" v-for="(item, index) in repaymentByList" />
                      </vs-select>
                    </div>
                    <vs-button v-round class="w-full only-border-btn medium" @click="openPlanConfigurationPopup(plan, index)">View plan configuration</vs-button>
                  </div>
                </div>
              </div>
            </vs-row>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>
    <!-- paylater product ends here -->

    <!-- New/ edit merchant > Credit Limit -->
    <vs-row v-if="showCreditLimit">
      <vs-card class="accordin-card">
        <vs-collapse accordion>
          <vs-collapse-item ref="creditLimit" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">Credit limit</h3>
            </div>
            <vs-row>
              <div class="input-grp">
                <label for="creditLimit" class="w-full text-xm font-normal">Limit</label>
                <money
                  name="creditLimit"
                  id="creditLimit"
                  v-bind="money3"
                  v-model="creditLimit"
                  data-vv-as="credit limit"
                  placeholder="Enter amount"
                ></money>
              </div>
            </vs-row>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>
    <!-- Credit Limit ends here -->

    <vs-row v-if="isOnboarding">
      <vs-card class="accordin-card mt-5">
        <vs-collapse accordion>
          <vs-collapse-item ref="paymentOptions" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">Applications</h3>
            </div>
            <div class="grid lg:grid-cols-3 gap-5">
              <div class="debit-card flex flex-col">
                <div class="card__header flex justify-between card-header px-5 mb-0">
                  <div class="flex flex-col">
                    <h4 class="m-0 card__title">Onboarding application</h4>
                  </div>
                </div>
                <div class="card__body px-5 pb-8">
                  <div class="card__content">
                    <p class="mt-4 mb-6 font-light">Submission date: <strong class="font-light text-dark-blue">{{formatDate(onboardingAgreementDate)}}</strong></p>
                  </div>
                  <vs-button v-round class="w-full only-border-btn medium" @click="goToOnboarding">View application</vs-button>
                </div>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>

    <!-- New/ edit merchant > Send account setup link to -->
    <vs-row>
      <vs-card class="accordin-card mt-5">
        <vs-collapse accordion>
          <vs-collapse-item ref="contactDetail" :open="true">
            <div slot="header">
              <h3 class="text-left card-title font-normal">Contact details<span class="mid-blue">*</span></h3>
            </div>
            <vs-row>
              <div class="px-8 mt-6 w-full pb-8">
                <vs-row>
                  <vs-col vs-w="4" class="textBlack">Communication type</vs-col>
                  <vs-col vs-w="4" class="textBlack">Email address</vs-col>
                  <vs-col vs-w="4" class="textBlack">Phone number</vs-col>
                </vs-row>

                <hr class="line-hr-thin mt-2 mb-2">
                <vs-row v-for="(contact, index) in contactDetails" :key="index" class="mt-8">
                  <vs-col vs-w="4"><p>{{ contact.name }}</p></vs-col>
                  <vs-col vs-w="4">
                    <vs-input :name="`email[${index}]`" v-model="contact.email" class="w-full" data-vv-as="email address" v-validate="'required|email'" />
                    <span v-show="errors.has(`email[${index}]`)" class="text-danger text-sm">{{ errors.first(`email[${index}]`) }}</span>
                  </vs-col>
                  <vs-col vs-w="4">
                    <vs-input
                      :name="`phone[${index}]`"
                      v-model="contact.phoneNumber"
                      v-mask="numberMask[index].mask"
                      class="w-full"
                      data-vv-as="phone number"
                      v-validate="'required|phoneFormat'"
                      v-on:input="checkValidPhoneNumber(index)"
                    />
                    <span v-show="errors.has(`phone[${index}]`)" class="text-danger text-sm">{{ errors.first(`phone[${index}]`) }}</span>
                  </vs-col>
                </vs-row>
              </div>
            </vs-row>
          </vs-collapse-item>
        </vs-collapse>
      </vs-card>
    </vs-row>
    <vs-popup v-show="addBankAccountPopupActive" class="add-bank-popup" :active.sync="addBankAccountPopupActive" @close="addBankPopupActive = false" :title="bankPopupTitle">
      <vs-row>
        <vs-col vs-w="12" class="my-4">
          <label>Account Name <span class="required-text">*</span></label>
          <vs-input class="w-full" v-validate="'required'" data-vv-validate-on="blur" data-vv-as="account name" data-vv-scope="addBank" v-model="accountName"
            placeholder="Enter account name" name="accountName" />
          <span class="text-danger text-sm" v-show="errors.has('addBank.accountName')">{{ errors.first("addBank.accountName") }}</span>
        </vs-col>

        <div class="grid grid-cols-2 gap-x-10 my-6">
          <div>
            <label class="w-full text-xm font-normal block">BSB <span class="required-text">*</span></label>
            <input v-mask="'###-###'" class="vs-inputx vs-input--input normal w-11/12" v-model="bsb" placeholder="Enter BSB" data-vv-scope="addBank" name="bsb" data-vv-validate-on="keyup" @keyup="handleBsb">
            <span class="text-danger text-sm block py-3" v-show="errors.has('addBank.bsb')">{{ errors.first("addBank.bsb") }}</span>
          </div>
          <div>
            <label class="w-full text-xm font-normal block">Account Number <span class="required-text">*</span></label>
            <vs-input class="w-11/12" v-validate="'required'" data-vv-scope="addBank" v-model="accountNumber" type="number" placeholder="Enter account number"
              data-vv-validate-on="blur" data-vv-as="account number" name="accountNumber"></vs-input>
            <span class="text-danger text-sm block py-3" v-show="errors.has('addBank.accountNumber')">{{ errors.first("addBank.accountNumber") }}</span>
          </div>
        </div>

        <vs-col vs-w="8">
          <div>
            <label class="w-full text-xm font-normal">Display Name <span class="required-text">*</span></label>
            <vs-input class="w-8/12" v-validate="'required|max:40'" v-model="displayName" data-vv-scope="addBank" data-vv-validate-on="blur"
              placeholder="Enter display name" data-vv-as="display name" name="displayName" />
            <span class="text-danger text-sm block py-3" v-show="errors.has('addBank.displayName')">{{ errors.first("addBank.displayName") }}</span>
          </div>
        </vs-col>

        <vs-col>
          <vs-row class="pr-6 mt-4" vs-w="8" vs-xs="12">
            <vs-checkbox v-model="isUsedForSettlement">This account will be used for settlement.</vs-checkbox>
          </vs-row>
          <vs-row class="pr-6 mt-4" vs-w="8" vs-xs="12">
            <vs-checkbox v-model="isUsedForBilling">This account will be used for billing.</vs-checkbox>
          </vs-row>
        </vs-col>

        <vs-col class="flex justify-end lg:mt-5 sm:mt-4">
          <vs-button class="text-xs mx-4 only-border-btn" v-round color="primary" @click="deleteBank" v-if="this.isUpdate && !(isUsedInPRT || isUsedInPR)">Delete</vs-button>
          <vs-button class="text-xs mx-4" v-round :disabled="!accountName || !bsb || !accountNumber || !displayName" color="primary" @click="addBankAccount" v-if="!this.isUpdate">Add account</vs-button>
          <vs-button class="text-xs mx-4" v-round :disabled="!accountName || !bsb || !accountNumber || !displayName" color="primary" @click="updateBankAccount" v-if="this.isUpdate">Update account</vs-button>
          <a class="text-xs flex items-center underline mid-blue" @click="closeModal">Cancel</a>
        </vs-col>
      </vs-row>
    </vs-popup>

    <!--product config popup starts-->
    <vs-popup id="holamundo" class="config-popup paymentSummaryPopup" :title="`${activePlan.productName} configuration`" :active.sync="popupActivo" @close="closePopup">
      <div class="w-full" v-if="activePlan.productType == 'B2C_BNPL'">
        <vs-col vs-w="12">
          <vs-row class="flex justify-between pay-later-card lg:p-4 md:p-3 p-2 items-start gray">
            <div class="flex flex-col justify-center items-center">
              <img :src="update" alt="update" />
              <span class="dark-blue text-xs mt-2"> Every</span>
              <span class="dark-blue text-xs">{{ `${this.everyNumber} ${this.weekOrMonthOrDay}` }}</span>
            </div>
            <div class="flex flex-col justify-center items-center">
              <img :src="playCircle" alt="playcircle" /><span class="dark-blue text-xs mt-2">Starts on</span>
              <span class="dark-blue text-xs">acceptance date</span>
            </div>
            <div class="flex flex-col justify-center items-center">
              <img :src="stopCircle" alt="stopcircle" />
              <span class="dark-blue text-xs mt-2">Ends after</span>
              <span class="dark-blue text-xs">{{ `${this.activePlan.noOfPayments} payments` }}</span>
            </div>
          </vs-row>
          <vs-table :data="paymentSchedules" class="payment-schedule-table mt-3">
            <template slot="thead">
              <vs-th class="text-base"><span class="font-medium text-grey">Payment date</span></vs-th>
              <vs-th class="text-base"><span class="font-medium text-grey">Amount</span></vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].value">
                  {{ formatScheduleDate(data[indextr].value) == formatScheduleDate(new Date()) ? `Today` : formatScheduleDate(data[indextr].value) }}
                </vs-td>
                <vs-td class="sec-row-payment" :data="data[indextr].label">
                  {{ data[indextr].label !== "0.00" ? `$ ${data[indextr].label}` : "-" }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="vs-table--content">
            <vs-row class="flex justify-between">
              <span class="text-lg dark-blue">Customer pays</span>
              <span class="text-lg amount">{{ this.totalCustomerPayable ? `$ ${addZeroes(this.totalCustomerPayable)}` : "-" }}</span>
            </vs-row>
            <vs-row class="mt-4">
              <span class="text-lg dark-blue">Merchant receives</span>
              <span class="text-lg amount">{{ this.merchantAmount? `$ ${addZeroes(this.merchantAmount)}` : "-" }}</span>
            </vs-row>
          </div>
        </vs-col>
      </div>

      <div class="w-full" v-if="['B2C_BNPO', 'B2C_BNPO_NC'].includes(activePlan.productType)">
        <vs-col vs-w="12">
          <div class="gray mb-5 items-center flex">
            <div><img :src="calenderImage" alt="calenderImage" /></div><p class="dark-blue text-base font-normal ml-4">Proceeds will be deducted on the {{ activePlan.initialPeriod }} days from the acceptance date
            </p>
          </div>
          <div class="b2c">
          <vs-row class="flex justify-between">
            <span class="text-lg dark-blue">Customer pays</span>
            <span class="text-lg amount">{{this.totalCustomerPayable ? `$ ${addZeroes(this.totalCustomerPayable)}` : "-"}}</span>
          </vs-row>
          <vs-row class="mt-4">
            <span class="text-lg dark-blue">Merchant receives</span>
            <span class="text-lg amount">{{this.merchantAmount ? `$ ${addZeroes(this.merchantAmount)}` : "-"}}</span>
          </vs-row>
          </div>
        </vs-col>
      </div>
    </vs-popup>
    <!-- popup ends -->
    <Note v-if="partnerId" />
    <pop-up :errorsList="errors" form-name="UserForm"></pop-up>
    <div class="flex flex-wrap justify-end mt-5 items-center">
      <vs-button v-round :disabled="isRequestSent" size="large" @click="prepareSubmit('save')">Save & exit</vs-button>
      <vs-button v-if="activeMerchant || !partnerId" v-round :disabled="isRequestSent" size="large" class="lg:mx-8 md:mx-4 sm:mx-2 mx-2" @click="prepareSubmit('activate')">Activate merchant</vs-button>
      <a class="mx-2 underline" v-round size="large" @click="$router.go(-1)">Cancel</a>
    </div>

    <vs-popup
      title='Confirm - disable "pay now" on the account?'
      header-icon="warning"
      class="close-icon-hidden custom-popup-decline"
      id="decline-popup"
      :active.sync="payNowWarningPopup"
    >
      <div class="w-full text-justify">
        <p class="flex mb-2">Enacting this change will disable pay-now entirely on the merchant account. "Pay-now" templates will be deleted, any "pending" payment requests created for "pay-now" only will be cancelled. Are you sure?</p>
      </div>
      <div class="popup-action-btn-container flex justify-end">
        <vs-button size="large" @click="updatePartner" action-btn>Continue</vs-button>
        <vs-button color="danger" @click="payNowWarningPopup = false" size="large" action-btn class="ml-6 md:ml-10">Cancel</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>

import { mapActions } from "vuex";
import { DEFAULT_PAYMENT_EXPIRY } from "./constant";
import { Validator } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { mask } from "vue-the-mask";
import { PlusIcon, XIcon } from "vue-feather-icons";
import MultiSelectExtended from "../../../components/MultiSelectExtended";
import BankCard from "../../../components/BankCard";
import BankDetailsCard from "../../../components/BankDetailsCard";
import "sweetalert2/src/sweetalert2.scss";
import _ from "lodash";
import { Money } from "v-money";
import moment from "moment";
import Note from "./notes.vue";
import PopUp from "@/views/components/ValidationPopup.vue";

const update = require("@/assets/images/update.png");
const playCircle = require("@/assets/images/play-circle.png");
const stopCircle = require("@/assets/images/stop-circle.png");
const calenderImage = require("@/assets/images/calender.png");
import S3ImageGenerator from "../../../components/S3ImageGenerator";
import SegmentedButtons from "../../../components/design-sys-components/components/SegmentedButtons";

const dictionary = {
  en: {
    attributes: {
      flipUsername: "username",
      companyName: "partner name",
      phoneNumber: "phone number",
      requestTypes: "request types",
      firstName: "first name",
      lastName: "last name",
      displayName: "display name",
      maskedMobileNumber: "phone number",
    },
    messages: {
      regex: () => "Phone number should be 10 digits",
      digits:(bsb) => "The bsb field must be 6 digits"
    },
  },
};
Validator.localize(dictionary);
export default {
  components: {
    PlusIcon,
    XIcon,
    MultiSelectExtended,
    Money,
    BankCard,
    BankDetailsCard,
    PopUp,
    S3ImageGenerator,
    SegmentedButtons,
    Note
  },
  directives: { mask },
  data() {
    return {
      appName: process.env.VUE_APP_NAME == "FlipPay" ? "Flip" : "Rello",
      alreadyHasPayNow: false,
      bankPopupTitle: "",
      credentialsSent: false,
      accountStatus: "",
      bankObjectId: "",
      activeMerchant: false,
      isUpdate: false,
      paynow: false,
      paylater: false,
      cardsList: [],
      selectedCards: [],
      allCardsSelected: false,
      paylaterProductsList: [],
      selectedProducts: [],
      allProductsSelected: false,
      cardOptions: "",
      addBankAccountPopupActive: false,
      bankAccountList: [],
      msf: "",
      surcharge: "",
      bankIndex: "",
      requestOptions: [],
      serverUrl: process.env.VUE_APP_API_URL,
      addBankPopupActive: false,
      money2: { precision: 2, suffix: " %" },
      money3: { precision: 2, prefix: "$ " },
      accountName: "",
      accountNumber: "",
      bsb: "",
      displayName: "",
      isUsedForSettlement: false,
      isUsedForBilling: false,
      accountId: "",
      isRequestSent: false,
      planSelect: [],
      currentBank: "",
      planSelectCopy: [],
      partnerId: "",
      paymentExpiry: DEFAULT_PAYMENT_EXPIRY,
      companyName: "",
      isSelectAll: false,
      firstName: "",
      lastName: "",
      onboardingId: "",
      onboardingRequestId: "",
      onboardingAgreementDate: "",
      phoneNumber: "",
      maskedMobileNumber: "",
      bankAccounts: [],
      requestTypes: [],
      paymentPlans: [],
      userType: "admin",
      role: "partner",
      requestTypesOptions: ["one-off", "recurring"],
      cardList: [],
      userAssignedCards: [],
      cardSet: {
        _id: "",
        title: "",
        icon: "",
        surcharge: "",
        card: "",
        partner: this.$route.params && this.$route.params.id ? this.$route.params.id : "",
      },
      payLater: false,
      abn: "",
      companyLogo: "",
      statusCallbackApiKey: "",
      amount: "1000",
      weekOrMonthOrDay: "",
      activePlan: "",
      everyNumber: "1",
      popupActivo: false,
      totalCustomerPayable: "",
      merchantAmount: "",
      paymentSchedules: [],
      update: update,
      playCircle: playCircle,
      stopCircle: stopCircle,
      calenderImage: calenderImage,
      isUiSetupComplete: false,
      bankIdsInPRTs: [],
      isUsedInPRT: false,
      bankIdsInPRs: [],
      isUsedInPR: false,
      msfRates: [],
      contactDetails: [
        {
          name: "Account owner",
          email: "",
          phoneNumber: ""
        },
        {
          name: "Accounts department",
          email: "",
          phoneNumber: ""
        },
        {
          name: "Technical support",
          email: "",
          phoneNumber: ""
        }
      ],
      numberMask: [
        {
          mask: "#### ### ###"
        },
        {
          mask: "#### ### ###"
        },
        {
          mask: "#### ### ###"
        },
      ],
      eftType: "",
      hasPermission: false,
      creditLimit: "",
      defaultManualAssessment: false,
      payNowOptions: ["CARDS", "EFT"],
      payNowWarningPopup: false,
      submitData: null,
      repaymentByList: [],
      merchantDescriptor: ""
    };
  },
  computed: {
    paymentOptions() {
      return { payNow: this.paynow, payLater: this.paylater };
    },

    isOnboarding() {
      return this.onboardingId && this.onboardingId.length > 0;
    },

    showCreditLimit() {
      return this.selectedProducts.some(item => item.productConfigType == "TWO_PARTY");
    }
  },
  methods: {
    ...mapActions("partner", [
      "storePartner",
      "fetchPartnerDetailById",
      "updatePartnerById",
      "sendCredentialsToMerchant",
    ]),
    ...mapActions("onboardingAdmin", ["calculateOnPayLater"]),
    ...mapActions("card", ["fetchAllCards", "deletePartnerCard"]),
    ...mapActions("paymentPlans", ["fetchAllPlans"]),
    ...mapActions("setting", ["fetchSetting"]),
    ...mapActions("admin", ["checkLogin"]),

    addPopUpClass(enabled) {
      if (enabled) {
        document.body.classList.add("custom-popup", "decline-popup");
      } else {
        document.body.classList.remove("custom-popup", "decline-popup");
      }
    },

    handleOverrideServiceFee(plan, index) {
      if (!plan.overrideServiceFee) {
        this.selectedProducts[index].msf = plan.defaultMsf;
      }

      this.$forceUpdate();
    },

    handleOverrideGreaterThanAmount(plan, index) {
      if (!plan.overrideGreaterThanAmount) {
        const product = this.paylaterProductsList.find(item => item.customPlanId == plan.customPlanId);

        if (product) {
          const manualAssessment = product.manualAssessmentCriteria.find(item => item.criteria == "AMOUNT_GREATER_THAN");

          if (manualAssessment) {
            this.selectedProducts[index].manualAssessmentGreaterThanAmount = parseFloat(manualAssessment.value);
          } else {
            this.selectedProducts[index].manualAssessmentGreaterThanAmount = parseFloat(0);
          }
        }
      }

      this.$forceUpdate();
    },

    handleManualAssessment() {
      this.$forceUpdate();
    },

    async checkAdminLogin() {
      await this.checkLogin().then(res => {
        this.hasPermission = (res.data.data.permissions["addBankAccounts"] && res.data.data.permissions["editBankAccounts"]) || false;
      });
    },

    getMsfRates(card) {
      let rates = [...this.msfRates];

      if (["mastercard", "visa"].includes(card.toLowerCase())) {
        rates = rates.filter(item => item.msf <= this.maxCardMsf);
      }

      return rates;
    },

    selectAll() {
      this.planSelect = this.paymentPlans;
    },

    //* functions for plan configuration popup start here
    async openPlanConfigurationPopup(plan, index) {
      this.activePlan = plan;
      this.popupActivo = true;

      await this.calculateOnPayLater({ planId: plan._id, msf: this.selectedProducts[index].msf }).then((result) => {
        const total = result.data.data.find(item => item.type == "Total");
        const disbursement = result.data.data.find(item => item.type == "Disbursement");
        const schedule = result.data.data.filter(item => item.type == "Payment");

        if (this.activePlan.productType == "B2C_BNPL") {
          this.payLaterSchedule = schedule.map((item) => {
            return {
              label: item.amount,
              value: new Date(item.date),
            };
          });
          this.paymentSchedules = this.payLaterSchedule;
          this.totalNumberOfPayments = this.payLaterSchedule.length;
        }

        this.totalCustomerPayable = total.amount;
        this.merchantAmount = disbursement.amount;
      });

      // for finding week month or day
      if (this.activePlan.paymentFrequency) {
        if (this.activePlan.paymentFrequency == "DAILY") {
          this.weekOrMonthOrDay = "day";
        }
        if (this.activePlan.paymentFrequency == "WEEKLY") {
          this.weekOrMonthOrDay = "week";
        }
        if (this.activePlan.paymentFrequency == "FORTNIGHTLY") {
          this.everyNumber = "2";
          this.weekOrMonthOrDay = "weeks";
        }
        if (this.activePlan.paymentFrequency == "MONTHLY") {
          this.weekOrMonthOrDay = "month";
        }
      }
    },

    checkValidPhoneNumber(value) {
      let checkNumber = this.contactDetails[value].phoneNumber;
      this.numberMask[value].mask = this.checkDynamicPhoneNumber(checkNumber);
    },

    checkDynamicPhoneNumber(checkNumber) {
      let mask = "#### ### ###";

      if (checkNumber && checkNumber.length > 0) {
        let numLength = checkNumber.length;
        let numberOne = "";
        let numberTwo = "";

        if (numLength >= 2) {
          numberOne = checkNumber.substring(0, 2);

          if (numberOne === "13") {
            numberTwo = checkNumber.split(" ").join("").substring(0, 4);
          }
        }

        if (["02", "03", "07", "08"].includes(numberOne)) {
          mask = "## #### ####";
        } else {
          mask = "#### ### ###";
        }

        if (numberOne === "13") {
          if (parseInt(numberTwo) == 1300) {
            mask = "#### ### ###";
          } else {
            mask = "## ## ##";
          }
        }
      }

      return mask;
    },

    handleMerchantDescriptorPress(event) {
      const charCode = event.which || event.keyCode;

      // Check if the pressed key corresponds to a special character
      if (charCode >= 33 && charCode <= 47 ||
          charCode >= 58 && charCode <= 64 ||
          charCode >= 91 && charCode <= 96 ||
          charCode >= 123 && charCode <= 126) {
          event.preventDefault();
      }
    },
    moment(date) {
      return moment(date).format("D-MMM-YY");
    },

    formatScheduleDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    getWeekDay(date) {
      return moment(date).format("dddd");
    },

    addZeroes(num) {
      num = String(num);
      const dec = num.split(".")[1];
      return Number(num).toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
    },

    closePopup() {
      this.weekOrMonthOrDay = "";
      this.activePlan = {};
      this.paymentSchedules = [];
      this.totalCustomerPayable = "";
      this.merchantAmount = "";
    },

    async getAllCards() {
      await this.fetchAllCards().then((res) => {
        this.cardsList = res.data.data;
      });
    },

    closeCard(index, id) {
      if (index > -1) {
        this.selectedCards.splice(index, 1);

        const cardIndex = this.cardsList.findIndex(item => item._id == id);

        if (cardIndex > -1) {
          this.cardsList[cardIndex].surcharge = this.cardsList[cardIndex].msf;
        }
      }
    },

    selectAllCards() {
      this.allCardsSelected = !this.allCardsSelected;

      if (this.allCardsSelected) {
        this.selectedCards = [...this.cardsList];
      } else {
        this.selectedCards = [];
      }
    },

    checkSelected() {
      this.allCardsSelected = (this.selectedCards.length == this.cardsList.length);
    },

    async getAllPaylaterProducts() {
      await this.fetchAllPlans("?page=1&limit=1000&sort=desc").then((res) => {
        this.paylaterProductsList = res.data.data.docs;
        this.paylaterProductsList = this.paylaterProductsList.map(item => {
          item.isManualAssessment = false;
          item.overrideServiceFee = false;
          item.overrideGreaterThanAmount = false;
          item.defaultMsf = parseFloat(item.msf);

          if (item.manualAssessmentCriteria && item.manualAssessmentCriteria.length) {
            const manualAssessment = item.manualAssessmentCriteria.find(mItem => mItem.criteria == "AMOUNT_GREATER_THAN");

            if (manualAssessment) {
              item.manualAssessmentGreaterThanAmount = parseFloat(manualAssessment.value);
            } else {
              item.manualAssessmentGreaterThanAmount = parseFloat(0);
            }
          }
          return item;
        });
      });
    },

    closeProduct(index) {
      if (index > -1) {
        this.selectedProducts.splice(index, 1);
      }
    },

    selectAllProducts() {
      this.allProductsSelected = !this.allProductsSelected;

      if (this.allProductsSelected) {
        this.selectedProducts = [...this.paylaterProductsList];
      } else {
        this.selectedProducts = [];
      }
    },

    checkSelectedProducts() {
      this.allProductsSelected = (this.selectedProducts.length == this.paylaterProductsList.length);
    },

    addBankAccountPopup() {
      this.bsb = "";
      this.errors.clear();
      this.bankPopupTitle = "Add bank account";
      this.accountName = "";
      this.accountNumber = "";
      this.displayName = "";
      (this.isUsedForSettlement = false),
        (this.isUsedForBilling = false),
        (this.isUpdate = false);
      this.addBankAccountPopupActive = true;
    },

    createUniqueId(character) {
      let firstBits = Math.floor(1000 + Math.random() * 9000);
      let secondBits = Math.floor(1000 + Math.random() * 9000);
      let uniqueId = `${character}-${firstBits}-${secondBits}`;
      return uniqueId;
    },

    getBankPayload(type = "create") {
      let bankAccountId = this.createUniqueId("A");

      let payload = {
        accountName: this.accountName,
        bsb: this.bsb.split("-").join(""),
        accountNumber: this.accountNumber,
        displayName: this.displayName,
        isUsedForSettlement: this.isUsedForSettlement,
        isUsedForBilling: this.isUsedForBilling,
        bankAccountId: bankAccountId,
      };

      if (type == "update") {
        payload["_id"] = this.bankObjectId;

        if (this.accountId) {
          payload["bankAccountId"] = this.accountId;
        }
      }

      return payload;
    },

    addBankAccount() {
      this.$validator.validate("addBank.*").then(async (result) => {
        if (result) {
          const payload = this.getBankPayload("create");

          this.bankAccountList.push(payload);
          this.addBankAccountPopupActive = false;
          this.clearBankFields();
          this.showMessage("Bank Account", "Bank Account has been added.", "success", "icon-check-circle");
          this.$vs.loading.close();
        }
      });
    },

    clearBankFields() {
      this.$nextTick(() => {
        this.accountName = "";
        this.bsb = "";
        this.accountNumber = "";
        this.displayName = "";
        this.isUsedForSettlement = false;
        this.isUsedForBilling = false;
        this.bankIndex = "";
        this.isUsedInPRT = false;
        this.isUsedInPR = false;
      });
    },

    updateBankAccount() {
      this.$validator.validate("addBank.*").then(async (result) => {
        if (result) {
          const payload = this.getBankPayload("update");

          // To update the bank list array
          const final_data = [ ...this.bankAccountList.slice(0, this.bankIndex), payload, ...this.bankAccountList.slice(this.bankIndex + 1)];
          this.bankAccountList = final_data;
          this.errors.clear();
          this.addBankAccountPopupActive = false;
          this.clearBankFields();
          this.showMessage("Bank Account", "Bank Account has been updated.", "success", "icon-check-circle");
          this.$vs.loading.close();
        }
      });
    },

    closeModal() {
      this.addBankAccountPopupActive = false;
      this.isUsedInPRT = false;
    },

    handleEditPopup(bankData, index) {
      this.bankPopupTitle = "Edit bank account";
      this.accountId = bankData.bankAccountId;
      this.addBankAccountPopupActive = true;
      this.isUpdate = true;
      this.bankObjectId = bankData._id;
      this.accountName = bankData.accountName;
      this.accountNumber = bankData.accountNumber.split(" ").join("");
      this.bsb = bankData.bsb;
      this.displayName = bankData.displayName;
      this.isUsedForSettlement = bankData.isUsedForSettlement;
      this.isUsedForBilling = bankData.isUsedForBilling;
      this.bankIndex = index;
      this.isUsedInPRT = this.bankIdsInPRTs.includes(bankData._id);
      this.isUsedInPR = this.bankIdsInPRs.includes(bankData._id);
    },

    deleteBank() {
      this.bankAccountList.splice(this.bankIndex, 1);
      this.closeModal();
    },

    gotoPlan(id) {
      this.$router.push({
        name: "pay-later-product",
        query: { id },
      });
    },

    prepareSubmit(event) {
      let bankWithBilling = [];
      let bankWithSettlement = [];

      this.bankAccountList.map((item) => {
        if (item.isUsedForSettlement) {
          bankWithSettlement.push(item);
        }

        if (item.isUsedForBilling) {
          bankWithBilling.push(item);
        }
      });

      if (event == "activate") {
        if (bankWithBilling.length == 0 && bankWithSettlement.length == 0) {
          return this.$vs.notify({
            color: "danger",
            title: "Bank",
            text: "At least one bank account should be settlement account and one bank account should be billing account",
          });
        }
        if (bankWithBilling.length == 0) {
          return this.$vs.notify({
            color: "danger",
            title: "Bank",
            text: "At least one bank account should be billing account",
          });
        }
        if (bankWithSettlement.length == 0) {
          return this.$vs.notify({
            color: "danger",
            title: "Bank",
            text: "At least one bank account should be settlement account",
          });
        }
      }

      this.$vs.loading();
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          let data = new FormData();

          if (!this.paynow && !this.paylater) {
            this.$vs.notify({
              color: "danger",
              title: "Payment Options",
              text: "At least one of paynow or paylater payment options is required",
            });
            this.$vs.loading.close();
            return;
          }

          if (this.paynow == true) {
            this.requestOptions = ["pay-now"];
          }

          if (this.paylater == true) {
            this.requestOptions = ["pay-later"];
          }

          if (this.paylater == true && this.paynow == true) {
            this.requestOptions = ["pay-now", "pay-later"];
          }

          data.append("requestOptions", JSON.stringify(this.requestOptions));

          if (this.partnerId && event == "save") {
            data.append("accountStatus", this.accountStatus);
          } else if (event == "save") {
            data.append("accountStatus", "Inactive");
          } else if (event == "activate") {
            data.append("accountStatus", "Active");
          }

          data.append("companyName", this.companyName);
          data.append("accountName", this.companyName);
          data.append("onboardingId", this.onboardingId);
          data.append("bankAccountList", JSON.stringify(this.bankAccountList));
          data.append("phoneNumber", this.maskedMobileNumber);
          data.append("role", this.role);

          if (this.companyLogo) {
            data.append("companyLogo", this.companyLogo);
          }

          data.append("abn", this.abn);
          data.append("payLaterPlans", JSON.stringify(this.selectedProducts));
          data.append("merchantDescriptor", this.merchantDescriptor);

          let cards = [];

          if (!this.partnerId) {
            cards = this.selectedCards.map((element) => {
              return {
                card: element._id,
                title: element.title,
                icon: element.icon,
                msf: element.msf,
                surcharge: element.surcharge,
              };
            });
          }
          if (this.partnerId) {
            cards = this.selectedCards.map((element) => {
              if (!element.fromDB) {
                return {
                  card: element._id,
                  title: element.title,
                  icon: element.icon,
                  msf: element.msf,
                  surcharge: element.surcharge,
                };
              }
              if (element.fromDB) {
                element.surcharge = element.surcharge;
                return element;
              }
            });
          }

          data.append("payNowPaymentOptions", JSON.stringify(this.paynow ? cards : []));
          data.append("bankAccounts", JSON.stringify(this.bankAccounts));
          data.append("userType", this.userType);
          data.append("firstName", this.firstName);
          data.append("paymentExpiry", this.paymentExpiry);
          data.append("lastName", this.lastName);
          data.append("assignedCards", JSON.stringify(this.userAssignedCards));
          data.append("event", event);
          data.append("contactDetails", JSON.stringify(this.contactDetails));
          data.append("creditLimit", this.creditLimit);
          data.append("eftType", this.payNowOptions.includes("EFT") ? "platform" : "merchant");
          data.append("payNowOptions", this.paynow ? JSON.stringify(this.payNowOptions) : []);

          this.submitData = {
            data: data,
            config: {
              header: {
                "Content-Type": "application/json",
              },
            },
          };

          if (!this.partnerId) {
            this.savePartner();
          } else {
            if (this.alreadyHasPayNow && !this.paynow) {
              this.$vs.loading.close();
              this.addPopUpClass(true);
              this.payNowWarningPopup = true;
            } else {
              this.updatePartner();
            }
          }
        } else {
          this.$vs.loading.close();
        }
      }).catch((ex) => {
        this.isRequestSent = false;
        this.$vs.loading.close();
      });
    },

    async savePartner() {
      if (!this.submitData) {
        this.$vs.loading.close();
        this.showMessage("Error", "Failed to get submit data", "danger", "icon-times");
        return;
      }

      await this.storePartner(this.submitData).then((result) => {
        this.$vs.loading.close();
        this.showMessage("Success", "Merchant has been created successfully.", "success", "icon-check-circle");
        this.$router.push({ name: "partners-list" });
      }).catch((ex) => {
        this.$vs.loading.close();
        this.showMessage("Error", ex.data.message, "danger", "icon-times");
      });
    },

    async updatePartner() {
      if (!this.submitData) {
        this.$vs.loading.close();
        this.showMessage("Error", "Failed to get submit data", "danger", "icon-times");
        return;
      }

      this.$vs.loading();
      this.submitData.id = this.partnerId;

      await this.updatePartnerById(this.submitData).then((result) => {
        this.$vs.loading.close();
        this.showMessage("Success", "Merchant has been updated successfully.", "success", "icon-check-circle");
        this.addPopUpClass(false);
        this.$router.push({ name: "partners-list" });
      }).catch((ex) => {
        this.$vs.loading.close();

        if (this.payNowWarningPopup) {
          this.addPopUpClass(false);
        }

        const message = ex.data ? ex.data.message : "Something went wrong";
        this.showMessage("Error", message, "danger", "icon-times");
      });
    },

    showMessage(title, message, color, icon) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        iconPack: "feather",
        position: "top-right",
        icon: icon,
      });
    },

    async getPartnerDetail(id) {
      await this.fetchPartnerDetailById(id).then(async (result) => {
        this.merchantDescriptor = result.data.data.merchantDescriptor || "";
        this.credentialsSent = result.data.data.credentialsSent;
        this.accountStatus = result.data.data.accountStatus;

        if (result.data.data.accountStatus == "Inactive") {
          this.activeMerchant = true;
        }

        if (result.data.data.requestOptions) {
          if (result.data.data.requestOptions.includes("pay-now")) {
            this.paynow = true;
            this.alreadyHasPayNow = true;
          }

          if (result.data.data.requestOptions.includes("pay-later")) {
            this.paylater = true;
          }
        }

        if (result.data.data.partnercardoptions) {
          let cards = [...result.data.data.partnercardoptions];
          cards.map((element) => {
            for (let i = 0; i < this.cardsList.length; i++) {
              if (element.card == this.cardsList[i]._id) {
                this.cardsList[i].fromDB = true;
                this.cardsList[i]._id = element._id;
                this.cardsList[i].card = element.card;
                this.cardsList[i].partner = element.partner;
                this.cardsList[i].msf = parseFloat(element.msf);
                this.cardsList[i].surcharge = parseFloat(element.surcharge);
                this.selectedCards.push(this.cardsList[i]);
              }
            }
          });
        }

        if (result.data.data.payLaterPlans) {
          let paylaterPlan = [...result.data.data.payLaterPlans];

          paylaterPlan.map((element) => {
            for (let i = 0; i < this.paylaterProductsList.length; i++) {

              if (element.customPlanId == this.paylaterProductsList[i].customPlanId) {
                this.paylaterProductsList[i].displayName = element.displayName || "";

                if (element.overrideServiceFee) {
                  this.paylaterProductsList[i].msf = parseFloat(element.msf);
                }

                if (element.overrideGreaterThanAmount) {
                  this.paylaterProductsList[i].manualAssessmentGreaterThanAmount = parseFloat(element.manualAssessmentGreaterThanAmount);
                } else {
                  const manualAssessment = (this.paylaterProductsList[i] && this.paylaterProductsList[i].manualAssessmentCriteria) ? this.paylaterProductsList[i].manualAssessmentCriteria.find(item => item.criteria == "AMOUNT_GREATER_THAN") : null;

                  this.paylaterProductsList[i].manualAssessmentGreaterThanAmount = manualAssessment ? parseFloat(manualAssessment.value) : 0;
                }

                this.paylaterProductsList[i].isManualAssessment = element.isManualAssessment || false;
                this.paylaterProductsList[i].overrideServiceFee = element.overrideServiceFee || false;
                this.paylaterProductsList[i].overrideGreaterThanAmount = element.overrideGreaterThanAmount || false;
                const repayment = this.repaymentByList.find(item => item._id == (element.repaymentBy || this.paylaterProductsList[i].repaymentBy));
                this.paylaterProductsList[i].repaymentBy = (repayment && repayment._id) ? repayment._id : "";

                if (element.referenceOrder && element.referenceOrder.length) {
                  this.paylaterProductsList[i].referenceOrder = element.referenceOrder;
                }

                this.selectedProducts.push(this.paylaterProductsList[i]);
              }
            }
          });
        }

        if (result.data.data.paymentRequestTemplates) {
          this.bankIdsInPRTs = result.data.data.paymentRequestTemplates.filter(item => item.deleted == false && item.linkedAccount).map(item => item.linkedAccount.bankId);
          this.bankIdsInPRTs = [...new Set(this.bankIdsInPRTs)];
        }

        if (result.data.data.paymentRequests) {
          this.bankIdsInPRs = result.data.data.paymentRequests.filter(item => (item.paymentStatus != "Completed" && (item.paymentPage || item.bankId))).map(item => item.bankId || item.paymentPage.bankId);
          this.bankIdsInPRs = [...new Set(this.bankIdsInPRs)];
        }

        if (result.data.data.banks) {
          this.bankAccountList = result.data.data.banks;
        }

        if (result.data.data.contactDetails.length > 0) {
          this.contactDetails = result.data.data.contactDetails;
        }
        // removing redundant id to make it similar to orginal plan
        this.planSelect = result.data.data.payLaterPlans.map((plan) => {
          return _.omit(plan, ["_id"]);
        });

        this.companyName = result.data.data.companyName;

        if (result.data.data.abn) {
          this.abn = result.data.data.abn;
        }

        if (result.data.data.onboardingId) {
          this.onboardingId = result.data.data.onboardingId;
        }

        if (result.data.data.onboarding) {
          this.onboardingRequestId = result.data.data.onboarding.onboardingRequestId;
          this.onboardingAgreementDate = result.data.data.onboarding.submittedDate;
        }

        if (result.data.data.firstName) {
          this.firstName = result.data.data.firstName;
        }

        // removing redundant id to make it similar to orginal plan
        this.planSelect = result.data.data.payLaterPlans.map((plan) => {
          return _.omit(plan, ["_id"]);
        });

        if (result.data.data.lastName) {
          this.lastName = result.data.data.lastName;
        }

        if (result.data.data.phoneNumber) {
          this.phoneNumber = result.data.data.phoneNumber;
          this.maskedMobileNumber = this.phoneNumber;
        }

        if (result.data.data.paymentExpiry) {
          this.paymentExpiry = result.data.data.paymentExpiry || DEFAULT_PAYMENT_EXPIRY;
        }

        if (result.data.data.requestTypes) {
          this.requestTypes = result.data.data.requestTypes;
        }

        if (this.paynow && result.data.data && result.data.data.payNowOptions && result.data.data.payNowOptions.length) {
          this.payNowOptions = result.data.data.payNowOptions;
        }

        this.payLater = result.data.data.payLater ? result.data.data.payLater : false;
        this.creditLimit = parseFloat(result.data.data.creditLimit) || 0;
      })
      .catch((ex) => {});
    },

    addCard() {
      this.userAssignedCards.push(JSON.parse(JSON.stringify(this.cardSet)));
    },

    async chooseCardType(event, cardSlot) {
      let cardDetails = this.cardList.find(function (card) {
        return card._id === event;
      });

      cardSlot.title = cardDetails.title;
      cardSlot.icon = cardDetails.icon;
      cardSlot.card = event;
    },

    prepareCardDelete(detail, key) {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "The card will be permanently deleted.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          self.deleteCard(detail, key);
        }
      });
    },

    deleteCard(detail, key) {
      if (detail._id) {
        this.deleteCardFromModel(detail._id);
      }
      this.userAssignedCards.splice(key, 1);
    },

    removePlanCard(index) {
      this.planSelect.splice(index, 1);
    },

    async deleteCardFromModel(id) {
      const status = await this.deletePartnerCard(id);

      if (status) {
        this.showMessage("Success", "Card has been removed.", "success", "icon-check-circle");
      }
    },

    goToOnboarding(){
      const url = `${process.env.VUE_APP_BASE_URL}onboarding-review/${this.onboardingRequestId}`
      window.open(url, '_blank')
    },

    formatDate(date) {
      if (!date) {
        return date;
      }

      return moment(date).format("DD MMM YYYY");
    },

    async getMsfSetting() {
      await this.fetchSetting("surcharge").then((res) => {
        this.msfRates = res.data.data.map((element) => {
          return {
            ...element,
            displayMsf: element.msf + " %"
          };
        });
      }).catch((ex) => {
        this.$vs.notify({
          title: "Error",
          text: "Error fetching setting",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
    },

    checkMsf(index) {
      const objIndex = this.msfRates.findIndex((obj) => obj.msf == this.selectedCards[index].msf);

      if (objIndex < 0) {
        this.errors.add({
          "field" : `msf${index}`,
          "msg": "Please select valid msf from the list"
        });
      } else {
        if (this.errors.has(`msf${index}`)) {
          this.errors.remove(`msf${index}`);
        }
      }

      if (this.selectedCards[index].surcharge > this.selectedCards[index].msf) {
        this.errors.add({
          "field": `surcharge${index}`,
          "msg": `The surcharge field must be ${this.selectedCards[index].msf} or less`
        });
      } else {
        if (this.errors.has(`surcharge${index}`)) {
          this.errors.remove(`surcharge${index}`);
        }
      }
    },

    assignDefaultMsf(index) {
      const objIndex = this.msfRates.findIndex((obj) => obj.msf == this.selectedCards[index].msf);

      if (objIndex < 0) {
        this.selectedCards[index].msf = "1.50";
        this.selectedCards[index].surcharge = "1.50";
      }
    },

    handleBsb() {
      if (this.errors.has("addBank.bsb")) {
        this.errors.remove("addBank.bsb");
      }

      if (!this.bsb) {
        this.errors.add({
          field: "bsb",
          scope: "addBank",
          msg: "The bsb field is required",
        });
        return;
      }

      let validBsb = false;
      const bsbData = this.bsb.split("-");

      if (bsbData.length == 2 && bsbData[1].length == 3) {
        validBsb = true;
      }

      if (!validBsb) {
        this.errors.add({
          field: "bsb",
          scope: "addBank",
          msg: "The bsb field must be 6 digits",
        });
      }
    },

    handlePayNow() {
      this.payNowOptions = this.paynow ? ["CARDS", "EFT"] : [];
      this.selectDefaultCards();
    },

    selectDefaultCards() {
      if (this.payNowOptions.includes("CARDS")) {
        const selectedCard = this.cardsList.filter((item) => {
          item.surcharge = item.msf;
          return item.slug == "visa" || item.slug == "mastercard";
        });

        this.selectedCards = selectedCard;
      } else {
        this.selectedCards = [];
      }
    },

    async getRepaymentBy() {
      await this.fetchSetting("repaymentBy").then((result) => {
        this.repaymentByList = result.data.data.filter(item => item.active);
      }).catch((ex) => {
        this.$vs.notify({
          title: ex.response.data.title,
          text: ex.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
    },

    showOverrideManualAssessment(plan) {
      return (plan.manualAssessmentCriteria && plan.manualAssessmentCriteria.find(item => item.criteria == "AMOUNT_GREATER_THAN")) ? true : false;
    }
  },

  watch: {
    payNowWarningPopup(val) {
      this.addPopUpClass(val);
    },

    selectedCards(val) {
      if (this.$refs.payNowPaymentMethods) {
        this.$refs.payNowPaymentMethods.maxHeight = "none !important";
      }
      this.assignDefaultMsf(this.selectedCards.length - 1);
    },

    paymentOptions(val) {
      if (this.$refs.bankCollapse) {
        this.$refs.bankCollapse.maxHeight = "none !important";
      }
    },

    bankAccountList(val) {
      if (this.$refs.bankCollapse) {
        this.$refs.bankCollapse.maxHeight = "none !important";
      }
    },

    selectedProducts() {
      if (this.$refs.paylaterProducts) {
        this.$refs.paylaterProducts.maxHeight = "none !important";
      }
    },
  },

  async created() {
    await this.checkAdminLogin();
    this.getMsfSetting();
    this.getAllCards();
    await this.getRepaymentBy();
    await this.getAllPaylaterProducts();

    if (this.$route.params.id) {
      this.partnerId = this.$route.params.id;
      this.getPartnerDetail(this.$route.params.id);
    }

    Validator.extend("surchargeField", {
      getMessage: (field) =>
        parseInt(this.activePlan.minimumAmount) > 0 &&
        (this.amount < parseInt(this.activePlan.minimumAmount) ||
          this.amount == parseInt(this.activePlan.minimumAmount))
          ? "Amount must be above $" + this.activePlan.minimumAmount
          : parseInt(this.activePlan.maximumAmount) > 0 &&
            (this.amount > parseInt(this.activePlan.maximumAmount) ||
              this.amount == parseInt(this.activePlan.maximumAmount))
          ? " Amount must be below $" + this.activePlan.maximumAmount
          : "",
      validate: (value) =>
        value < parseInt(this.activePlan.maximumAmount) &&
        value > parseInt(this.activePlan.minimumAmount),
    });
    Validator.extend("requiredAmount", {
      getMessage: (field) => "Amount field is required",
      validate: (value) => !!value,
    });
    this.$validator.extend("phoneFormat", {
      getMessage: () => "The phone number format is invalid.",
      validate: (value) =>
        value.match(
          /^(^04\(?\d{2}\)?[\s.-]\d{3}[\s.-]\d{3})|(^1300[\s.-]\d{3}[\s.-]\d{3})|(^1800[\s.-]\d{3}[\s.-]\d{3})|(^13[\s.-]\d{2}[\s.-]\d{2}$)|(^02[\s.-]\d{4}[\s.-]\d{4})|(^03[\s.-]\d{4}[\s.-]\d{4})|(^07[\s.-]\d{4}[\s.-]\d{4})|(^08[\s.-]\d{4}[\s.-]\d{4})/
        ) !== null,
    });
  },

  async beforeMount() {
    await this.fetchAllCards().then((res) => {
      this.cardList = res.data.data;
    }).catch((ex) => { });
  },
};
</script>

